export default __webpack_public_path__ + "static/media/cloud-upload-alt.d89bf5b8.svg";